import { withStyles, withTheme } from '@material-ui/core/styles';
import React from 'react';
import PropTypes from 'prop-types';

// ui/ux
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Chip from '@material-ui/core/Chip';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';

// ours
import ErrorSign from '../../../ErrorSign';
import Waiting from '../../../Waiting';

// icons
import DeleteIcon from '@material-ui/icons/Delete';
import SaveIcon from '@material-ui/icons/Save';
import CheckIcon from '@material-ui/icons/Check';
import TextFieldsIcon from '@material-ui/icons/TextFields';
import DoneAllIcon from '@material-ui/icons/DoneAll';
import DoneIcon from '@material-ui/icons/Done';
import PhotoIcon from '@material-ui/icons/Photo';
import RoomIcon from '@material-ui/icons/Room';

// GLOBALS
const API_HOST = process.env.REACT_APP_ADMIN_API_HOST;

const styles = (theme) => ({
  cloud: {
    '& > div.MuiChip-root': {
      margin: theme.spacing(0.5)
    },
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2)
  },
  input: {
    '& .MuiFormLabel-root.Mui-focused': {
      color: theme.palette.text.secondary
    },
    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.text.secondary
    },
    marginBottom: theme.spacing(2)
  },
  excerpt: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.getContrastText(theme.palette.primary.main),
    fontWeight: 'bold'
  },
  table: {
    marginBottom: theme.spacing(2)
  }
});

class SortInputs extends React.Component {
  constructor(props) {
    super(props);
    console.log('SortInputs', JSON.stringify({ ...props, classes: null, theme: null, onComplete: null }));
    this.state = {
      error: false,
      nameKeys: [],
      nameOverride: '',
      photoKeys: [],
      selections: [],
      step: 0,
      stepSel: [],
      stepType: ['TEXT'],
      usedKeys: [],
      stepGeo: false
    };

    this.nextInput = this.nextInput.bind(this);
    this.nextStep = this.nextStep.bind(this);

    this._xhrFormsQuestions = {};
  }
  componentDidMount() {
    const { form, topic } = this.props;
    this._xhrFormsQuestions.cancel && this._xhrFormsQuestions.cancel();
    window.genericGet(`${API_HOST}/admin/v0/forms/questions/${form.form_id}/${topic}`, this._xhrFormsQuestions, (e, formQuestions) => {
      if (e) {
        console.error(e);
        return this.setState({ error: e });
      }

      // "opts": [
      //     [
      //         {
      //             "label": "Not busy at all",
      //             "value": "not_busy_at_all",
      //             "image_url": null
      //         },
      this.setState({
        formQuestions: formQuestions.filter((d) => {
          return (
            ['SELECT_MANY', 'TEXT', 'PHOTO', 'NUMBER', 'SCREENSHOT'].includes(d.input_type) ||
            (d.input_type === 'SELECT_ONE' && d.opts.map((d) => d.length > 1).reduce((a, b) => a && b))
          );
        })
      });
    });
  }
  cloudSelect(index) {
    // {
    //   "input_type": "SELECT_ONE",
    //   "label": "Athens Regional Location",
    //   "names": [
    //     "athens_regional_location"
    //   ],
    //   "hints": [
    //     "Please tell us which region of Athens your housing is located within."
    //   ],
    //   "opts": [

    const { formQuestions, stepSel } = this.state;
    // names of the selected cloud item:
    const names = formQuestions[index].names;
    // all related indices, selected included:
    const relevant_indices = [index];
    // iterate through all questions & find other cloud items w/ the same names:
    for (let i = 0; i < formQuestions.length; i++) {
      // don't intersect self:
      if (i === index) continue;
      // don't intersect if input_type's don't match:
      if (formQuestions[i].input_type !== formQuestions[index].input_type) {
        continue;
      }
      const intersection = formQuestions[i].names.filter((d) => names.includes(d));
      if (intersection.length > 0 && stepSel.indexOf(i) === -1) {
        relevant_indices.push(i);
      }
    }
    // allow photos & screenshots to be combined, just don't do it automatically:
    let newStepType = this.state.stepType || formQuestions[index].input_type;
    if (newStepType.indexOf('PHOTO') !== -1 || newStepType.indexOf('SCREENSHOT') !== -1) {
      newStepType = ['PHOTO', 'SCREENSHOT'];
    }
    this.setState((s) => ({
      stepSel: [...s.stepSel, ...relevant_indices],
      stepType: newStepType
    }));
  }
  renderCloud() {
    const { classes } = this.props;
    const { stepType, stepSel, formQuestions, usedKeys } = this.state;
    const usedInputIndices = [...usedKeys, ...stepSel];
    const usedInputKeys = usedKeys.flatMap((d) => formQuestions[d].names);

    return (
      <Box className={classes.cloud}>
        {formQuestions
          .filter((d, i) => usedInputIndices.indexOf(i) === -1 && d.names.map((d1) => usedInputKeys.indexOf(d1) === -1).reduce((a, b) => a && b, true))
          .map((d) => {
            let icon;
            if (d.input_type === 'TEXT') {
              icon = <TextFieldsIcon />;
            } else if (d.input_type === 'SELECT_ONE') {
              icon = <DoneIcon />;
            } else if (d.input_type === 'SELECT_MANY') {
              icon = <DoneAllIcon />;
            } else if (d.input_type === 'PHOTO' || d.input_type === 'SCREENSHOT') {
              icon = <PhotoIcon />;
            }
            return (
              <Chip
                icon={icon}
                disabled={stepType && !stepType.includes(d.input_type)}
                key={d.input_type + d.label + JSON.stringify(d).hashCode()}
                label={d.label}
                onClick={() => this.cloudSelect(formQuestions.indexOf(d))}
              />
            );
          })}
      </Box>
    );
  }
  renderNamePrompt() {
    const { classes, topic } = this.props;
    const { stepSel, nameOverride } = this.state;
    return (
      <React.Fragment>
        <Typography>
          Select questions for the topic "<span className={classes.excerpt}>{topic}</span>" from this form that best represent this form's place name:
        </Typography>
        {this.renderCloud()}
        <TextField
          onKeyDown={(e) => {
            if (e.keyCode === 13) {
              this.nextInput();
            }
          }}
          value={nameOverride}
          onChange={(e) => {
            this.setState({ nameOverride: e.target.value });
          }}
          disabled={stepSel.length > 0}
          className={classes.input}
          label="Custom place name representation"
          variant="outlined"
          fullWidth
        />
        {this.renderTableForStepSel()}
        {this.renderButtons(stepSel.length > 0 || nameOverride.length > 0)}
      </React.Fragment>
    );
  }
  renderTableForStepSel() {
    const { classes } = this.props;
    const { step, stepSel, formQuestions } = this.state;
    if (stepSel.length === 0) {
      return null;
    }
    return (
      <TableContainer component={Paper} className={classes.table}>
        <Table aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell>Question</TableCell>
              <TableCell>Type</TableCell>
              <TableCell>Keys</TableCell>
              <TableCell>Options</TableCell>
              <TableCell>Hints</TableCell>
              <TableCell></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {stepSel.map((d, i) => (
              <TableRow key={formQuestions[d].label}>
                <TableCell component={i === 0 ? 'th' : null} scope={i === 0 ? 'row' : null}>
                  {formQuestions[d].label}
                </TableCell>
                <TableCell>{formQuestions[d].input_type}</TableCell>
                <TableCell>
                  <ul>
                    {formQuestions[d].names.map((d1, i1) => (
                      <li key={i1}>{d1}</li>
                    ))}
                  </ul>
                </TableCell>
                <TableCell>
                  {['SELECT_ONE', 'SELECT_MANY'].includes(formQuestions[d].input_type) && (
                    <ul>{formQuestions[d].opts.map((d1) => d1.map((d2, i2) => <li key={i2}>{`${d2.value} : ${d2.label}`}</li>).reduce((a, b) => a.concat(b), []))}</ul>
                  )}
                </TableCell>
                <TableCell>
                  <ul>
                    {formQuestions[d].hints
                      .filter((d) => d && d.trim().length > 0)
                      .map((d1, i1) => (
                        <li key={i1}>{d1}</li>
                      ))}
                  </ul>
                </TableCell>
                <TableCell>
                  <IconButton
                    color="secondary"
                    component="span"
                    onClick={() => {
                      this.setState((s) => {
                        const idx = s.stepSel.indexOf(d);
                        const stepSel = [...s.stepSel.slice(0, idx), ...s.stepSel.slice(idx + 1)];
                        return {
                          stepSel,
                          // special case for first two steps, keep input_type:
                          stepType: stepSel.length === 0 && step > 1 ? null : s.stepType
                        };
                      });
                    }}
                  >
                    <DeleteIcon />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    );
  }
  renderPhotoPrompt() {
    const { formQuestions, usedKeys, stepSel } = this.state;

    return (
      <React.Fragment>
        <Typography>Select questions from this form that best represent this form's image:</Typography>
        {this.renderCloud()}
        {this.renderTableForStepSel()}
        {this.renderButtons(stepSel.length > 0 && stepSel.length + usedKeys.length < formQuestions.length, stepSel.length > 0)}
      </React.Fragment>
    );
  }
  nextInput() {
    const { step, stepSel, nameOverride } = this.state;
    if (step === 0) {
      // SAVE NAME
      if (stepSel.length) {
        this.setState((s) => ({
          step: 1,
          stepType: ['PHOTO', 'SCREENSHOT'],
          usedKeys: [...s.usedKeys, ...s.stepSel],
          stepSel: [],
          nameKeys: s.stepSel.map((d) => ({ ...s.formQuestions[d], geo: s.stepGeo })),
          stepGeo: true
        }));
      } else if (nameOverride.length > 0) {
        this.setState(() => ({
          step: 1,
          stepType: ['PHOTO', 'SCREENSHOT'],
          stepGeo: true
        }));
      }
    } else if (step === 1) {
      // SAVE PHOTO
      this.setState((s) => ({
        step: 2,
        stepType: null,
        usedKeys: [...s.usedKeys, ...s.stepSel],
        stepSel: [],
        photoKeys: s.stepSel.map((d) => ({ ...s.formQuestions[d], geo: s.stepGeo })),
        stepGeo: false
      }));
    } else {
      // SAVE INPUT
      this.setState((s) => ({
        step: s.step + 1,
        stepType: null,
        usedKeys: [...s.usedKeys, ...s.stepSel],
        stepSel: [],
        selections: [...s.selections, s.stepSel.map((d) => ({ ...s.formQuestions[d], geo: s.stepGeo }))],
        stepGeo: false
      }));
    }
  }
  nextStep() {
    const { onComplete } = this.props;
    const { formQuestions, nameKeys, step, stepSel, stepGeo, nameOverride } = this.state;

    let selections;
    let photoKeys;
    const stepSelMapped = stepSel.map((d) => ({ ...formQuestions[d], geo: stepGeo }));

    if (step === 1) {
      photoKeys = stepSelMapped;
      selections = [];
    } else {
      if (stepSel.length > 0) {
        selections = this.state.selections.concat([stepSelMapped]);
        photoKeys = this.state.photoKeys;
      } else {
        selections = this.state.selections;
        photoKeys = this.state.photoKeys;
      }
    }

    const reduce = (arr) =>
      arr.reduce(
        (a, b) => ({
          labels: a.labels.concat(b.label),
          names: a.names.concat(b.names),
          opts: b.opts && b.opts.length > 0 ? a.opts.concat(b.opts) : a.opts,
          input_type: b.input_type,
          geo: a.geo || b.geo,
          configured: a.configured || b.configured
        }),
        {
          labels: [],
          names: [],
          opts: [],
          input_type: null,
          geo: false,
          configured: false
        }
      );

    onComplete(
      reduce(nameKeys),
      nameOverride,
      reduce(photoKeys),
      selections.map((d) => reduce(d))
    );
  }

  renderButtons(i, s) {
    const { stepSel, stepGeo } = this.state;
    return (
      <Grid container direction="row" justifyContent="flex-end" alignItems="center" spacing={1}>
        <Grid item>
          <Button
            variant={stepGeo ? 'contained' : 'outlined'}
            color="secondary"
            startIcon={<RoomIcon />}
            onClick={() => {
              this.setState({
                stepGeo: !stepGeo
              });
            }}
          >
            Consider Geography
          </Button>
        </Grid>
        <Grid item>
          <Button disabled={!i} variant="outlined" color="secondary" onClick={this.nextInput} startIcon={<SaveIcon />}>
            Next Input
          </Button>
        </Grid>
        <Grid item>
          <Button disabled={!s} variant="outlined" color="secondary" onClick={this.nextStep} startIcon={stepSel.length > 0 ? <SaveIcon /> : <CheckIcon />}>
            Next Step
          </Button>
        </Grid>
      </Grid>
    );
  }
  renderGeneric() {
    const { stepSel, usedKeys, formQuestions } = this.state;
    return (
      <React.Fragment>
        <Typography>Select questions that should be grouped together:</Typography>
        {this.renderCloud()}
        {this.renderTableForStepSel()}
        {this.renderButtons(stepSel.length > 0 && stepSel.length + usedKeys.length < formQuestions.length, true)}
      </React.Fragment>
    );
  }
  render() {
    const { error, formQuestions, step } = this.state;
    if (error) {
      return <ErrorSign height={300} />;
    }

    if (!formQuestions) {
      return <Waiting />;
    }

    if (step === 0) {
      return this.renderNamePrompt();
    } else if (step === 1) {
      return this.renderPhotoPrompt();
    }

    return this.renderGeneric();
  }
}

SortInputs.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,

  form: PropTypes.object.isRequired,
  topic: PropTypes.string.isRequired,

  onComplete: PropTypes.func.isRequired
};
SortInputs.defaultProps = {};

export default withTheme(withStyles(styles)(SortInputs));
